import React from 'react';
import { getSale, updateSale, updateBranch, updateResponse, getClubs, getBranch, resendEmailService } from "../../api/saleapi";
import { getStateProvinces } from '../../api/giftApi';
import {
    Form,
    Label, Input,
    Button, Col, Row,
} from 'reactstrap';
import { Redirect } from "react-router-dom";
import { connect } from 'react-redux';
import { formatEditDate, formatInTimeZoneDateTime } from '../../helpers';
import cloneDeep from 'lodash/cloneDeep';
import '../css/EditCreate.css';
import '../css/OverlayLoader.css'
import InputFeedback from '../utils/InputFeedback';
import FormValidator from '../FormValidation'
import * as Constants from '../../store/Constants'
import feedback from '../utils/feedback';
import { customLoadingOverlay } from '../css/CustomLoadingOverlay'
import LoadingOverlay from 'react-loading-overlay-ts'

class SaleEdit extends React.Component {

    constructor(props) {
        super(props);
        let sale = null;
        if (this.props.route.location.state) {
            if (this.props.route.location.state.from === 'view') {
                this.props.route.history.push('/secure/sales');
                this.props.route.history.push(this.props.route.match.url);
            }
            if (this.props.route.location.state.from === 'gift') {
                this.props.route.history.push('/secure/gifts');
                this.props.route.history.push(this.props.route.match.url);
            }
            if (this.props.route.location.state.from === 'giftEdit') {
                this.props.route.history.push(`/secure/giftEdit/${this.props.route.location.state.id}`);
                this.props.route.history.push(this.props.route.match.url);
            }
        }
        this.validator = new FormValidator([
            {
                field: 'firstName',
                method: 'isEmpty',
                validWhen: false,
                message: 'First Name is required.',
            },
            {
                field: 'lastName',
                method: 'isEmpty',
                validWhen: false,
                message: 'Last Name is required.',
            },
            {
                field: 'email',
                method: 'isEmpty',
                validWhen: false,
                message: 'Email is required.',
            },
            {
                field: 'email',
                method: this.isEmail,
                validWhen: false,
                message: 'Email is not a valid email format',
            },
            {
                field: 'donorPostalCode',
                method: this.isDonorPostalCode,
                validWhen: false,
                message: 'Zip code is not a valid format',

            }
        ])

        this.state = {
            loading: false,
            readOnly: true,
            sale: sale,
            cancel: false,
            saved: false,
            error: false,
            edit: false,
            baseState: '',
            errorMessage: [],
            toggle: false,
            validation: this.validator.valid(),
            disableResendDonors: false,
        };

        this.handleCancel = this.handleCancel.bind(this);
    }

    isEmail = state =>
        !state.match(
            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )

    isDonorPostalCode = state =>
        !(state || '').match(
            /^(?:\d{5}(?:-\d{4})?|[A-Za-z]\d[A-Za-z]\s?\d[A-Za-z]\d)?$/
        )

    componentDidMount() {
        if (this.state.sale == null) {
            const saleId = this.props.route.match.params.saleId;
            this.props.getSaleConnect(function (result, _this) { _this.getDataSale(result, _this) }, this, saleId)
        }

        if (this.state.stateProvince == null) {
            this.props.getStateProvinces(function (result, _this) {
                _this.getDataStates(result, _this)
            }, this)
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.forceUpdate) {
            this.setState({ forceUpdate: false })
            this.handleSubmit()
        }

        if (this.props.updateResult !== prevProps.updateResult) {
            console.log('a response exists')
            const result = this.props.updateResult
            console.log(result, 'this is the result')

            if (result) {
                if (result.data.success) {
                    console.log(result.data.success)
                    const x = JSON.stringify(cloneDeep(this.state.sale), function (key, value) {
                        if (value === null) {
                            return ''
                        }
                        return value
                    })
                    this.setState(state => ({
                        baseState: x,
                        saved: true,
                        edit: false,
                        validation: this.validator.valid(),
                        readOnly: true
                    }))
                    this.submitted = false
                    this.props.getSaleConnect(
                        function (result, _this) {
                            _this.getDataSale(result, _this)
                        },
                        this,
                        this.state.sale.saleId
                    )
                    if (this.state.forceUpdate === null) window.location.reload()

                }
            }
        }

        if (this.props.resendEmailResponse !== prevProps.resendEmailResponse) {

            if (this.props.resendEmailResponse) {
                if (this.props.resendEmailResponse.success) {
                    this.setState({ loading: false })
                }
            }
        }
    }

    handleEdit() {
        this.setState(state => ({
            readOnly: !state.readOnly,
            edit: true,
        }))
    }

    handleCancel = () => {
        this.setState({
            cancel: true,
            validation: this.validator.valid()
        })
    }

    // Calls API for updating club on form submit
    handleSubmit = event => {
        if (event) event.preventDefault()

        const updVal = this.state.sale
        this.setState({ recipient: updVal }, () => {
            const validation = this.validator.validate(this.state.sale)
            this.setState({ validation })

            this.submitted = true

            if (!this.state.forceUpdate && this.state.forceUpdate != null) {
                this.setState({ forceUpdate: null })
                this.props.updateSale(updVal)
            }
            else if (validation.isValid) {
                this.props.updateSale(updVal)
            }
            else {
                this.setState({ loading: false })
            }
        })
    }

    isInvalid(e) {
        const input = e.target
        if (input.value) {
            input.classList.remove('is-invalid')
        } else {
            input.classList.add('is-invalid')
        }
    }

    getDataSale(data, _this) {
        var x = JSON.stringify(cloneDeep(data.data.data))
        _this.setState({
            sale: data.data.data,
            baseState: x
        })
    }

    formatEditDate(date) {
        var options = { year: 'numeric', month: '2-digit', day: '2-digit', hour: "2-digit", minute: "2-digit" };

        return new Date(date).toLocaleDateString("en-US", options).toLowerCase().replace(/,/g, ' -');
    }

    getDataStates(data, _this) {
        _this.setState({
            stateProvinces: data.data.data,
            loading: false,
        })
    }

    renderStateProvinces() {
        return this.state.stateProvinces?.map((stateProvince, index) => {
            return (
                <option id={stateProvince.stateProvinceId} key={index}>
                    {stateProvince.state}
                </option>
            )
        })
    }

    handleResendEmail() {
        this.setState({
            loading: true,
            disableResendDonors: true
        })
        this.props.resendEmailServiceConnect(
            function (result, _this) {
                _this.getDataSale(result, _this)
            },
            this,
            this.state.sale.saleId
        )
    }

    render() {
        const sale = this.state.sale
        const { loading } = this.state

        if (this.state.cancel) {
            return <Redirect
                to={{
                    pathname: `/secure/sales`,
                }}
            />;
        }

        const validation = this.state.validation; {/*this.submitted* 
        ? this.validator.validate(this.state.recipient)
        : this.state.validation*/}

        return (
            <div className="card">
                <LoadingOverlay active={loading} spinner styles={customLoadingOverlay} >
                    <div className="card-header text-center">
                        {this.state.readOnly ? 'View Sale' : 'Edit Sale'}
                    </div>

                    {sale && <div className="card-body fs-12">
                        <Form onSubmit={this.handleSubmit}>
                            <div className="row">
                                <div className="col-md-6">
                                    <Col>
                                        <Row form>
                                            <Col style={{ flex: 10 }}>
                                                <Label htmlFor='lastName' className="required-hint mt-4 mr-0"><strong>Last name</strong></Label>
                                                <Input readOnly={this.state.readOnly}
                                                    id="lastName"
                                                    name="lastName"
                                                    type="input"
                                                    className={this.state.readOnly ? 'form-control' : 'input-editable'}
                                                    maxLength="30"
                                                    required={this.submitted}
                                                    value={sale.lastName}
                                                    onChange={e => {
                                                        this.isInvalid(e)
                                                        const x = sale
                                                        x.lastName = e.target.value
                                                        this.setState({ sale: x })
                                                    }}
                                                    onKeyDown={e => {
                                                        if (Constants.editorExcludeCharacters.indexOf(e.key) >= 0) {
                                                            e.preventDefault()
                                                        }
                                                    }}
                                                />
                                                {!this.state.readOnly && <InputFeedback feedbackText={feedback.productDisplayName} id='lastName' />}
                                                <span className="help-block">{validation.lastName.message}</span>
                                            </Col>
                                            <Col style={{ flex: 2 }}>
                                                <Label htmlFor='middleInitial' className="mt-4"><strong>MI</strong></Label>
                                                <Input readOnly={this.state.readOnly}
                                                    type="input"
                                                    id="middleInitial"
                                                    name="middleInitial"
                                                    className={this.state.readOnly ? 'form-control' : 'input-editable'}
                                                    maxLength="2"
                                                    value={sale.middleInitial}
                                                    onChange={e => {
                                                        const x = sale
                                                        x.middleInitial = e.target.value
                                                        this.setState({ sale: x })
                                                    }}
                                                    onKeyDown={e => {
                                                        if (Constants.editorExcludeCharacters.indexOf(e.key) >= 0) {
                                                            e.preventDefault()
                                                        }
                                                    }}
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col>
                                        <Label htmlFor='firstName' className="required-hint mt-4 mr-0"><strong>First name</strong></Label>
                                        <Input readOnly={this.state.readOnly}
                                            type="input"
                                            id="firstName"
                                            name="firstName"
                                            className={this.state.readOnly ? 'form-control' : 'input-editable'}
                                            maxLength="30"
                                            required={this.submitted}
                                            value={sale.firstName}
                                            onChange={e => {
                                                this.isInvalid(e)
                                                const x = sale
                                                x.firstName = e.target.value
                                                this.setState({ sale: x })
                                            }}
                                            onKeyDown={e => {
                                                if (Constants.editorExcludeCharacters.indexOf(e.key) >= 0) {
                                                    e.preventDefault()
                                                }
                                            }}
                                        />
                                    </Col>
                                    <Col >
                                        <Label htmlFor='street' className="mt-4"><strong>Street address</strong></Label>
                                        <Input readOnly={this.state.readOnly}
                                            type="text"
                                            id="street"
                                            name="streetAddress"
                                            className={this.state.readOnly ? 'form-control' : 'input-editable'}
                                            maxLength="150"
                                            required={this.submitted}
                                            value={sale.donorStreetAddress}
                                            onChange={e => {
                                                this.isInvalid(e)
                                                const x = sale
                                                x.donorStreetAddress = e.target.value
                                                this.setState({ sale: x })
                                            }}
                                            onKeyDown={e => {
                                                if (Constants.editorExcludeCharacters.indexOf(e.key) >= 0) {
                                                    e.preventDefault()
                                                }
                                            }}
                                        />
                                    </Col>
                                    <Col>
                                        <Row form>
                                            <Col style={{ flex: 4 }}>
                                                <Label htmlFor='city' className="mt-4"><strong>City</strong></Label>
                                                <Input readOnly={this.state.readOnly}
                                                    type="text"
                                                    id="city"
                                                    name="city"
                                                    className={this.state.readOnly ? 'form-control' : 'input-editable'}
                                                    maxLength="255"
                                                    required={this.submitted}
                                                    value={sale.donorCity}
                                                    onChange={e => {
                                                        const x = sale
                                                        x.donorCity = e.target.value
                                                        this.setState({ sale: x })
                                                    }}
                                                    onKeyDown={e => {
                                                        if (Constants.editorExcludeCharacters.indexOf(e.key) >= 0) {
                                                            e.preventDefault()
                                                        }
                                                    }}
                                                />
                                            </Col>
                                            <Col style={{ flex: 2 }}>
                                                <Label htmlFor='stateProvince' className="mt-4"><strong>State</strong></Label>
                                                {this.state.readOnly && <Input readOnly
                                                    type="text"
                                                    id="stateProvince"
                                                    name="stateProvince"
                                                    value={sale.donorStateProvince}
                                                />}
                                                {!this.state.readOnly && (<select
                                                    id="stateProvince"
                                                    name="stateProvince"
                                                    className='input-editable form-control'
                                                    value={sale.stateProvince}
                                                    onChange={e => {
                                                        const x = sale
                                                        x.donorStateProvince = e.target.value
                                                        this.setState({ sale: x })
                                                    }}
                                                >
                                                    {<option />}
                                                    {(this.renderStateProvinces())}
                                                    { }
                                                </select>)}
                                            </Col>
                                            <Col style={{ flex: 3 }}>
                                                <Label htmlFor='zipCode' className="mt-4"><strong>ZIP code</strong></Label>
                                                <Input readOnly={this.state.readOnly}
                                                    type="string"
                                                    id="zipCode"
                                                    name="zipCode"
                                                    className={(this.state.readOnly ? 'form-control' : 'input-editable') +
                                                        (!this.state.readonly && sale.donorPostalCode && this.isDonorPostalCode(sale.donorPostalCode) ? ' is-invalid' : '')}
                                                    maxLength="15"
                                                    required={this.submitted}
                                                    title={!this.state.readOnly && this.isDonorPostalCode(sale.donorPostalCode) ? "The zip code must be either ##### (US 5 digits), #####-#### (US Zip+4), or A1A 1A1 (Canada) format." : undefined}
                                                    value={sale.donorPostalCode}
                                                    onChange={e => {
                                                        const x = sale
                                                        x.donorPostalCode = e.target.value
                                                        this.setState({ sale: x })
                                                    }}
                                                    onKeyDown={e => {
                                                        if (Constants.editorExcludeCharacters.indexOf(e.key) >= 0) {
                                                            e.preventDefault()
                                                        }
                                                    }}
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col>
                                        <Label htmlFor='email' className="mt-4"><strong>Email address</strong></Label>
                                        <Input readOnly={this.state.readOnly}
                                            type="input"
                                            id="email"
                                            name="email"
                                            autoComplete="email"
                                            className={this.state.readOnly ? 'form-control' : 'input-editable'}
                                            maxLength="256"
                                            value={sale.email}
                                            onChange={e => {
                                                const x = sale
                                                x.email = e.target.value
                                                this.setState({ sale: x })
                                            }}
                                            onKeyDown={e => {
                                                if (Constants.editorExcludeCharacters.indexOf(e.key) >= 0) {
                                                    e.preventDefault()
                                                }
                                            }}
                                        />
                                    </Col>
                                    <Col>
                                        <Label htmlFor='telephone' className="mt-4"><strong>Telephone</strong></Label>
                                        <Input readOnly={this.state.readOnly}
                                            type="input"
                                            id="telephone"
                                            name="telephone"
                                            className={this.state.readOnly ? 'form-control' : 'input-editable'}
                                            maxLength="100"
                                            value={sale.telephone}
                                            onChange={e => {
                                                const x = sale
                                                x.telephone = e.target.value
                                                this.setState({ sale: x })
                                            }}
                                            onKeyDown={e => {
                                                if (Constants.editorExcludeCharacters.indexOf(e.key) >= 0) {
                                                    e.preventDefault()
                                                }
                                            }}
                                        />
                                    </Col>
                                    <Col>
                                        <div className="text-right float-bottom">
                                        </div>
                                    </Col>
                                </div>
                            </div>
                            <div className='row'>
                                <div className="col-md-6">
                                    <Col className="text-right d-flex flex-wrap justify-content-center flex-row">
                                        <Button
                                            onClick={this.handleResendEmail.bind(this)}
                                            disabled={this.state.disableResendDonors}
                                            className={this.state.readOnly ? 'mail-large-btn' : 'd-none'}>
                                            RESEND DONOR EMAILS
                                        </Button>
                                    </Col>
                                </div>
                                <div className='col-md-6'>
                                    <Col className="text-right d-flex flex-wrap justify-content-center flex-row">
                                        <Button onClick={this.handleCancel.bind(this)} className="cancel-btn">CANCEL</Button>
                                        <Button onClick={this.handleEdit.bind(this)} className={this.state.readOnly ? 'mx-4 mail-btn' : 'd-none'}>EDIT</Button>
                                        <Button onClick={this.handleSubmit.bind(this)} className={this.state.readOnly ? 'd-none' : 'mx-4 mail-btn'} type="submit" color="primary">SAVE</Button>
                                        {/*<Button onClick={this.handleEdit.bind(this)} className={this.state.readOnly ? 'mx-2 cancel-btn' : 'd-none'}>EDIT</Button>
                                        <Button onClick={this.handleFormSubmit.bind(this)} type="submit" color="primary" className={this.state.readOnly ? 'd-none' : 'mx-2 cancel-btn'}>SAVE</Button>*/}
                                    </Col>
                                </div>
                            </div>
                        </Form>
                        <Col>
                            <hr />
                        </Col>
                        <Col>
                            <Row>
                                <div className="col-md-1">
                                    <div className="inline-label"><strong>ID</strong></div>
                                    <p className="editFooterText">{sale.saleId}</p>
                                </div>
                                <div className="col-md-3">
                                    <div className="inline-label"><strong>Created by</strong></div>
                                    <p className="editFooterText">{sale.createdBy}</p>
                                </div>
                                <div className="col-md-3">
                                    <div className="inline-label"><strong>Created date</strong></div>
                                    <p className="editFooterText">
                                        {formatInTimeZoneDateTime(sale.createdDate, sale.branchIanaTimeZoneId)}
                                    </p>
                                </div>
                                <div className="col-md-2">
                                    <div className="inline-label"><strong>Updated by</strong></div>
                                    <p className="editFooterText">{sale.updatedBy}</p>
                                </div>
                                <div className="col-md-3">
                                    <div className="inline-label"><strong>Updated date</strong></div>
                                    <p className="editFooterText">
                                        {formatInTimeZoneDateTime(sale.updatedDate, sale.branchIanaTimeZoneId)}
                                    </p>
                                </div>
                            </Row>
                        </Col>
                    </div>
                    }
                </LoadingOverlay>
            </div >
        );
    }
}
export default connect(
    state => {
        return {
            sale: state.data.sale,
            updateResult: state.data.updateResult,
            resendEmailResponse: state.data.resendEmailSaleResponse,
        }
    },
    dispatch => ({
        getSaleConnect: (callback, context, id) => { dispatch(getSale(callback, context, id)) },
        updateSale: (callback, context) => { dispatch(updateSale(callback, context)) },
        updateResponse: response => { dispatch(updateResponse(response)) },
        getStateProvinces: (callback, context) => { dispatch(getStateProvinces(callback, context)) },
        resendEmailServiceConnect: (callback, context, id) => { dispatch(resendEmailService(callback, context, id)) }
    })
)(SaleEdit);

